import React, { useState } from 'react'
import { ToggleButton, IconLockSolid, IconUnlockLine } from '@instructure/ui'

export default function ToggleLock(props) {
  const [locked, setLock] = useState(true)

  const handleClick = () => {
    const newState = !locked
    setLock(newState)
    props.onChange(newState)
  }

  return <ToggleButton
    size='small'
    status={locked ? 'pressed' : 'unpressed'}
    renderIcon={locked ? IconLockSolid : IconUnlockLine}
    screenReaderLabel={locked ? 'Show' : 'Hide'}
    renderTooltipContent={locked ? 'Show' : 'Hide'}
    onClick={handleClick}
  />
}
